import React from 'react';

import Text from '@sats-group/ui-lib/react/text';

import type { PaymentSummary as Props } from './payment-summary.props';

const PaymentSummary: React.FunctionComponent<Props> = ({
  partials,
  total,
}) => (
  <div className="payment-summary">
    <div className="payment-summary__line">
      <Text size={Text.sizes.large} theme={Text.themes.emphasis}>
        {total.label}
      </Text>
      <Text size={Text.sizes.large} theme={Text.themes.emphasis}>
        {total.value}
      </Text>
    </div>
    <div className="payment-summary__partials">
      {partials.map(({ label, value }) => (
        <div key={label} className="payment-summary__line">
          <Text size={Text.sizes.small}>{label}</Text>
          <Text size={Text.sizes.small}>{value}</Text>
        </div>
      ))}
    </div>
  </div>
);

export default PaymentSummary;
